<template>
    <div>

        <div class="bg-darker lightest mt-2 py-2 px-4" v-if="getReservationCalculations">

            <div>

                <div class="d-flex flex-row justify-content-between align-items-baseline" v-if="getReservationCalculations.discountValue > 0">
                    <span v-if="getReservationCalculations.discountValueType == 1">Discount ({{getReservationCalculations.discountValue}}%)</span>
                    <span v-if="getReservationCalculations.discountValueType == 0">Discount ({{getReservationCalculations.discountValue}}€)</span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{ formatPrice(getReservationCalculations.totalDiscounts) }} €</span>
                </div>

                <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span>Total</span>
                    <span v-if="getIsLoadingCalculations" class="font-weight-600 fs-largest"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="font-weight-600 fs-largest">{{formatPrice(getReservationCalculations.grandTotal)}} €</span>
                </div>

                <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span>
                        <span>Deposit</span>
                        <span v-if="getReservationCalculations.depositPaymentType == 2 && getReservationCalculations.depositType == 1"> ({{getReservationCalculations.depositValue}}%)</span>
                        <span v-if="getReservationCalculations.depositPaymentType == 1"> (Full amount)</span>
                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.grandTotalDepositValueRequired)}} €</span>
                </div>
                <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span>
                        <span>Comissions (total)</span>
                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.grandTotalCommission)}} €</span>
                </div>

                <!-- old working -->
                <!-- <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span class="d-flex align-items-center">
                        Product Commission <span class="px-1" v-if="!localReservation.attachCommission.IsToOverwriteProduct">({{getReservationCalculations.entityCommissionToProductValue}}%)</span>
                        <span class="d-flex px-1" v-if="localReservation.attachCommission.IsToOverwriteProduct">
                            <input type="number" class="glued-right px-2 py-0 text-center border-0" style="width: 40px;" max="100" v-model="localReservation.attachCommission.productValue" @input="overrideCommissionChanged">
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-0" style="width: auto !important;" @click="switchCommissionType('product')" v-if="localReservation.attachCommission.ProductValueType == 1">%</div>
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-0" style="width: auto !important;" @click="switchCommissionType('product')" v-if="localReservation.attachCommission.ProductValueType == 0">€</div>
                        </span>
                        <span class="fs-small dark pointer mr-2 border-dark radius-normal px-1" v-if="localReservation.attachCommission.IsToOverwriteProduct" @click="refreshCalculations">Apply</span>
                        <span class="fs-small dark pointer" @click="editingCommissionToogle">{{localReservation.attachCommission.IsToOverwriteProduct? 'use default' : 'edit'}}</span>
                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.totalProductCommissionToEntityGrossprice)}} €</span>
                </div> -->

                <div class="d-flex flex-row justify-content-between align-items-baseline mt-1 medium" v-for="commissionType in comissionTypes" v-if="commissionType.active">
                    <span class="d-flex align-items-center ml-2">
                        {{commissionType.label}} <span class="px-1" v-if="!localReservation.attachCommission['IsToOverwrite'+commissionType.type]">
                            ({{getReservationCalculations['entityCommissionTo'+commissionType.type+'Value']}}{{getReservationCalculations['entityCommissionTo'+commissionType.type+'Type'] == 1? '%':'€'}})
                        </span>  <!-- ERROnao é sempre %  -->
                        <span class="d-flex px-1" v-if="localReservation.attachCommission['IsToOverwrite'+commissionType.type]">
                            <input type="number" class="glued-right px-2 py-0 text-center border-0" style="width: 40px;" v-model="localReservation.attachCommission[commissionType.type+'Value']" @input="overrideCommissionChanged($event, commissionType.type)">
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-0" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="localReservation.attachCommission[commissionType.type+'ValueType'] == 1">%</div>
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-0" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="localReservation.attachCommission[commissionType.type+'ValueType'] == 0">€</div>
                        </span>
                        <span class="fs-small dark pointer mr-2 border-dark radius-normal px-1" v-if="localReservation.attachCommission['IsToOverwrite'+commissionType.type]" @click="refreshCalculations">Apply</span>
                        <span class="fs-small dark pointer" @click="editingCommissionToogle(commissionType.type)">{{localReservation.attachCommission['IsToOverwrite'+commissionType.type]? 'use default' : 'edit'}}</span>
                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations['total'+commissionType.type+'CommissionToEntityGrossprice'])}} €</span>
                </div>
                <!-- DEBUG -->
                <div class="mt-5" v-if="false && loggedUserAccessList">
                    ---------------------- Debug -----------------------
                    <div>User can sell components: {{loggedUserAccessList.isAllowedSellComponents? 'yes':'no'}}</div>
                    <div>User can sell transport: {{loggedUserAccessList.isAllowedSellTransports? 'yes':'no'}}</div>
                    <!-- <div>Is channel open: {{loggedUserAccessList.isChannelOpen? 'yes':'no'}}</div>
                    <div>Users channel name: {{loggedUserAccessList.channel.name}}</div> -->
                </div>

                <!-- DEBUG -->
                <div class="mt-5" v-if="false">
                    <div>Debug: Input</div>

                    <div>
                        <span>Product:</span>
                        <input type="checkbox" v-model="localReservation.attachCommission.IsToOverwriteProduct">
                        <input type="number" v-model="localReservation.attachCommission.productValue">
                        <input type="number" v-model="localReservation.attachCommission.productValueType">
                    </div>

                    <div>
                        <span>Component:</span>
                        <input type="checkbox" v-model="localReservation.attachCommission.IsToOverwriteComponent">
                        <input type="number" v-model="localReservation.attachCommission.componentValue">
                        <input type="number" v-model="localReservation.attachCommission.componentValueType">
                    </div>

                    <div>
                        <span>Transport:</span>
                        <input type="checkbox" v-model="localReservation.attachCommission.IsToOverwriteTransport">
                        <input type="number" v-model="localReservation.attachCommission.transportValue">
                        <input type="number" v-model="localReservation.attachCommission.transportValueType">
                    </div>

                    <div>
                        <button @click="refreshCalculations">Calc!</button>
                    </div>
                    <div>
                        <span>0 -> € | 1 -> %</span>
                    </div>
                </div>
                <div class="mt-5" v-if="false">
                    <div>Debug: just read</div>
                    <div>Product: {{getReservationCalculations.entityCommissionToProductValue}} {{getReservationCalculations.entityCommissionToProductType == 0? '€':'%'}}</div>
                    <div>Component: {{getReservationCalculations.entityCommissionToComponentValue}} {{getReservationCalculations.entityCommissionToComponentType == 0? '€':'%'}}</div>
                    <div>Transport: {{getReservationCalculations.entityCommissionToTransportValue}} {{getReservationCalculations.entityCommissionToTransportType == 0? '€':'%'}}</div>
                </div>

            </div>

        </div>

        <!-- <button class=" bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-largest py-3 pointer" :disabled="noTicketsSelected || $v.$invalid" :class="{'disabled': noTicketsSelected || $v.$invalid}" @click="openPayModal" >PAY {{formatPrice(reservationTotalCost.withDiscount.withVat)}} EUR</button> -->
        <div class="d-flex">
            <button
                class="bg-color-1 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer"
                :disabled="noTicketsSelected || $v.$invalid || getIsAddingReservation"
                :class="{'disabled': noTicketsSelected || $v.$invalid}"
                @click="openPayModal">
                    Payment
            </button>

            <button
                class="bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2"
                :disabled="noTicketsSelected || $v.$invalid || getIsAddingReservation"
                :class="{'disabled': noTicketsSelected || $v.$invalid}"
                @click="saveReservation(false)">
                    {{saveButtonLabel}}
            </button>

            <button
                class="bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2"
                :disabled="noTicketsSelected || $v.$invalid || getIsAddingReservation"
                :class="{'disabled': noTicketsSelected || $v.$invalid}"
                @click="saveReservation(true)">
                    {{saveAndPrintButtonLabel}}
            </button>

        </div>
        <div class="d-flex" v-if="localReservation.creatorAgent && false">
            <button class="bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer mr-2" :disabled="noTicketsSelected || $v.$invalid || getIsAddingReservation" :class="{'disabled': noTicketsSelected || $v.$invalid}" @click="saveReservation(false)">{{clickedSave? 'Saving...':'Save'}}</button>
            <button class="bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer" :disabled="noTicketsSelected || $v.$invalid || getIsAddingReservation" :class="{'disabled': noTicketsSelected || $v.$invalid}" @click="saveReservation(true)">{{clickedSaveAndPrint? 'Saving...':'Save and Print'}}</button>
        </div>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import Loader from '@/tools/loaders/loader1'

import { reservationsMixin } from '@/mixins/reservations'

export default {
    data:function() {
        return{
            localReservation: {},
            clickedSave: false,
            clickedSaveAndPrint: false,
            comissionTypes:[
                {
                    type: 'Product',
                    label: 'Ticket',
                    active: true
                },
                {
                    type: 'Component',
                    label: 'Extras',
                    active: true
                },
                {
                    type: 'Transport',
                    label: 'Transport',
                    active: false
                },
            ]
        }
    },
    validations: {
        reservation:{
            customer: {
                name: {
                    required
                },
                // surname: {
                //     required
                // },
                // phone: {
                //     required
                // },
                email: {
                    email,
                }
            }
        }
    },
    props: {
        reservation: {
            type: Object
        },
        noTicketsSelected: {
            type: Boolean,
            default: false
        }
    },
    created: function () {
        this.localReservation = this.reservation
    },
    mixins:[
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'account',
            'getReservationCalculations',
            'getIsLoadingCalculations',
            'getIsAddingReservation'

        ]),
        costTotal: function() {
            let total = 0;
            let totalWithVat = 0;

            //ticket cost
            for(let personType of this.localReservation.event.eventGenderPrices){
                total += personType.value * personType.quantityToBook;
                totalWithVat += personType.valueCalculated * personType.quantityToBook;
            }

            //extras
            for(let extra of this.localReservation.product.extras){
                //both now have taxes, without taxes needs to be worked on
                total += extra.item.grossprice * extra.quantity;
                totalWithVat += extra.item.priceIncludeTaxes * extra.quantity;
            }

            return {
                total: total,
                totalWithVat: totalWithVat
            }

        },
        agentCommissionPercent: function(){
            if(this.localReservation.billing.agentCommision){
                let commissionPercet = this.selectedAgentComissions.defaultCommission

                this.selectedAgentComissions.commissionRelations.find(commissionRelation => {
                    if(commissionRelation.productId == this.localReservation.product.id){
                        commissionPercet = commissionRelation.commissionValue;
                    }
                })

                return commissionPercet;
            } else {
                return null
            }
        },
        discountValue: function(){
            if(this.localReservation.billing.discountValue){
                if(this.localReservation.billing.discountType == 1){
                    return Number(this.costTotal.totalWithVat) * (Number(this.localReservation.billing.discountValue) / 100);
                } else {
                    return this.localReservation.billing.discountValue
                }
            } else {
                return false
            }
        },
        costTotalDiscounted: function() {
            if(this.localReservation.billing.discountValue){
                this.localReservation.helper.totalToPay = this.costTotal.totalWithVat - this.discountValue;
                return {
                    total: this.costTotal.total - this.discountValue,
                    totalWithVat: this.costTotal.totalWithVat - this.discountValue
                }
            } else {
                this.localReservation.helper.totalToPay = this.costTotal.totalWithVat;
                return this.costTotal
            }
        },
        saveButtonLabel: function () {
            if(this.clickedSave){
                return 'Saving'
            }

            let referanceToMakeChanges = this.selectedSellerAccessList // this.selectedSellerUserAccessList or this.loggedUserAccessList

            if(!referanceToMakeChanges || !referanceToMakeChanges.channel){
                return 'Save'
            }

            if(referanceToMakeChanges.channel.isInvoiceAutomatic == true){
                return 'Checkout'
            } else if(referanceToMakeChanges.channel.isInvoiceAutomatic == false){
                return 'Save'
            }
        },
        saveAndPrintButtonLabel: function () {
            if(this.clickedSave){
                return 'Saving'
            }

            let referanceToMakeChanges = this.selectedSellerAccessList // this.selectedSellerUserAccessList or this.loggedUserAccessList

            if(!referanceToMakeChanges || !referanceToMakeChanges.channel){
                return 'Save and print'
            }

            if(referanceToMakeChanges.channel.isInvoiceAutomatic == true){
                return 'Print and Checkout'
            } else if(referanceToMakeChanges.channel.isInvoiceAutomatic == false){
                return 'Save and print'
            }
        }
    },
    methods: {
        ...mapActions([
            'openModal',
            'createNewReservation',
            'setReservationCalculations',
            'setReservation',
            'printInvoice',
            'addFloatingNotification',
            'setReservation'
        ]),
        openPayModal: function() {
            if(this.getIsAddingReservation){
                this.$toasted.info('Already creating reservation, please wait.');
                return false
            }
            this.setReservation(this.localReservation)
            this.openModal('ReservationPay')
        },
        // checkReservationBookingQuestion: function () {
        //     let bookingQuestionPromise = new Promise((resolve, reject) => {
        //
        //         if(this.reservation.event.bookingQuestionIsActive && this.reservation.event.bookingQuestionIsActive == true){
        //             // alert(this.reservation.product.bookingQuestion
        //             this.setReservation(this.reservation)
        //             this.openModal({
        //                 name: 'bookingQuestion',
        //                 callback: (e) => {
        //                     resolve(e)
        //                 }
        //             })
        //         } else {
        //             resolve("No question.")
        //         }
        //
        //     })
        //
        //     return bookingQuestionPromise
        //
        // },
        saveReservation: function(printTicket) {
            if(this.getIsAddingReservation){
                this.$toasted.info('Already creating reservation, please wait.');
                return false
            }


            if(printTicket){
                this.clickedSaveAndPrint = true
            } else {
                this.clickedSave = true
            }

            let vm = this;

            //check if agent and there is a deposit, if so adds it as a payment
            if(this.localReservation.creatorAgent && this.getReservationCalculations.grandTotalDepositValueRequired > 0){
                this.applyDeposit();
            }

            this.createNewReservation({supplierId: this.account.supplierId, reservation: this.localReservation}).then(response => {
                if(response == 'invalid'){
                    return false;
                }

                if (response.status == 200) {
                    this.$toasted.success('Reservation created successfully');
                    this.$router.push({ name: 'reservations' });

                    // this.$notify({
                    //       group: 'notifications',
                    //       position: 'bottom right',
                    //       title: null,
                    //       text: '<a href="/reservations/view/'+response.data.id+'" target="_blank"><h1>Ticket '+this.formatTicketNumber(response.data.id)+'</h1>'+response.data.customer.name+' <br>'+response.data.event.product.name+'</a>',
                    //       duration: 100000,
                    // });

                    this.addFloatingNotification(
                        {
                            type: -1,
                            title: 'Ticket '+this.formatTicketNumber(response.data.id),
                            message: response.data.customer.name+' <br>'+response.data.event.product.name,
                            bookingId: response.data.id,
                        },
                        'info',
                        {
                            link: '/reservations/view/'+response.data.id
                        }
                    )

                    if(printTicket){
                        axios.get('/api/booking/GetTicket', {
                            params: {
                                supplierId: this.account.supplierId,
                                bookingId: response.data.id,
                                type: 'vertical'
                            }
                        }).then(response => {


                            this.openByteArrayNewTab(response.data)
                            //
                            // pdfWindow.print();
                            // pdfWindow.close();

                        })

                        // print invoice
                        let referanceToMakeChanges = this.selectedSellerAccessList // this.selectedSellerUserAccessList or this.loggedUserAccessList
                        if(response.data.bookingInvoices.length > 0 && response.data.bookingInvoices[0].id && referanceToMakeChanges.channel.isInvoiceAutomatic == true){
                            vm.printInvoice(response.data.bookingInvoices[0].id).then(responsePrintInvoice =>{
                                if(responsePrintInvoice.status == 200){
                                    vm.openByteArrayNewTab(responsePrintInvoice.data)
                                }
                            }).catch(err => {

                            })
                        }

                    }
                } else {
                    this.clickedSaveAndPrint = false
                    this.clickedSave = false
                }
            }).catch(error => {
                this.clickedSaveAndPrint = false
                this.clickedSave = false
            });
        },
        applyDeposit: function() {
            let vm = this
            let depositValue = this.getReservationCalculations.grandTotalDepositValueRequired;
            // alert('Depoist: '+depositValue);
            this.$set(this.localReservation.billing, 'payments', [
                {
                    type: -100,
                    value: this.getReservationCalculations.grandTotalDepositValueRequired,
                    currency: "€",
                    treasurerAgent: this.localReservation.creatorAgent
                    // treasurerUserAccount: vm.account
                }
            ])
        },
        switchCommissionType: function(type) {
            //type can be: product, component, transport
            // this.localReservation.attachCommission.ProductValueType = 1
            // for now comission is always %
            if(this.localReservation.attachCommission[type+'ValueType'] == 0){
                this.localReservation.attachCommission[type+'ValueType'] = 1
            } else {
                this.localReservation.attachCommission[type+'ValueType'] = 0
            }

            this.refreshCalculations()
        },
        editingCommissionToogle: function(type) {
            //type can be: product, component, transport
            if(this.localReservation.attachCommission['IsToOverwrite'+type]){

                this.refreshCalculations()
            } else {
                this.localReservation.attachCommission[type+'Value'] = this.getReservationCalculations['entityCommissionTo'+type+'Value']
                this.localReservation.attachCommission[type+'ValueType'] = 1
            }
            this.localReservation.attachCommission['IsToOverwrite'+type] = !this.localReservation.attachCommission['IsToOverwrite'+type]
        },
        overrideCommissionChanged: function(e, type) {
            //example type = 'Product'
            console.log('type', type);
            //type can be: product, component, transport
            if(e.data == null) {
                this.localReservation.attachCommission[type+'Value'] = null
            }
            // this.localReservation.attachCommission['IsToOverwrite'+type+'Component'] = true
            // this.localReservation.attachCommission[type+'ComponentValueType'] = 1
            // this.localReservation.attachCommission[type+'ComponentValue'] = e.target.value
            this.localReservation.attachCommission['IsToOverwrite'+type+'Component'] = true
            this.localReservation.attachCommission[type+'ValueType'] = 1
            // this.localReservation.attachCommission[type+'Value'] = e.target.value
            //this.refreshCalculations()
        },
        refreshCalculations: function() {
            this.setReservationCalculations(this.localReservation)
        }
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss">
@import '../../../../../assets/scss/_variables.scss';
button.disabled{
    cursor: not-allowed;
    background-color: $light !important;
}
</style>



// WEBPACK FOOTER //
// TotalAndPay.vue?ed5f75b8